


import React, { Component } from 'react';
import './Style.css';
import '../../../custom.css';
import selectImage from '../../../images/select-meta.svg';

export class Goals extends Component {

    constructor(props) {
        super(props);
        this.state = {
            goals: []
        }
    }

    componentDidMount() {

        this.GetGoalByUserId();

    }

    componentDidUpdate() {
        
    }

    async GetGoalByUserId() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Letter/GetGoalByUserId`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState({ goals: data });
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Cargando los planes por tema',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async openImage(e) {
        this.setState({ imageSelected: e.currentTarget.src })
        document.querySelector('#btnOpenImage').click();
    }

    render() {

        return (
            <div className="mt-5 row panel-goals global pre-line-text col-lg-12">

                <button id="btnOpenImage" data-toggle="modal" data-target="#openImage" hidden></button>
                <div class="modal fade" id="openImage" tabindex="-1" role="dialog" aria-labelledby="closeLetterModal" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Cerrar carta de logros</h5>
                                <button type="button" id="closeModalCloseLetter" class="closeModal" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">

                                <img src={this.state.imageSelected} />

                            </div>
                            <div class="modal-footer"> <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>


                <h2>Mis metas</h2>

                {
                    this.state.goals.map(e =>

                        <div className="w-100">


                            <li class="list-group-item border-bottom d-flex">
                                <div className="col-3">
                                    {e.photo ? <img src={e.photo} className="w-100 pointer img-model" onClick={(e) => { this.openImage(e)}} /> : <img className="w-100" src={require('../../../images/avatar.png')} />}
                                </div>
                                <div className="col-8">
                                    <a href={`/comunidad/carta-de-logro/${e.id}`}><h6 className="entradilla">{e.title}</h6></a>
                                    <span className="text-small small">{e.topicName}</span>
                                </div>

                            </li>


                        </div>

                    )
                }
            </div>
        );
    }
}
